var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../../elements/Basic");

var _Header = _interopRequireWildcard(require("./Header"));

var _Standard = _interopRequireDefault(require("./Standard"));

var _Substitution = _interopRequireDefault(require("./Substitution"));

var _Goal = _interopRequireDefault(require("./Goal"));

var _Card = _interopRequireDefault(require("./Card"));

var _PropsHelper = require("../../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Commentary/Events/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Event = function (_React$Component) {
  (0, _inherits2.default)(Event, _React$Component);

  var _super = _createSuper(Event);

  function Event() {
    (0, _classCallCheck2.default)(this, Event);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Event, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          message = _this$props.message,
          matchMinute = _this$props.matchMinute,
          away = _this$props.away,
          scoreHome = _this$props.scoreHome,
          scoreAway = _this$props.scoreAway,
          period = _this$props.period,
          match = _this$props.match;
      var event = null,
          center = away === undefined,
          header = matchMinute ? _react.default.createElement(_Header.default, {
        isPenaltyShootout: period === 'PENALTY_SHOOTOUT',
        minute: matchMinute,
        center: center,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27,
          columnNumber: 17
        }
      }) : null;

      switch (type) {
        case 'RED_CARD':
        case 'YELLOW_CARD':
        case 'SECOND_YELLOW_CARD':
          header = _react.default.createElement(_Header.default, {
            minute: matchMinute,
            away: away,
            center: center,
            card: type,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 38,
              columnNumber: 26
            }
          });
          event = _react.default.createElement(_Card.default, (0, _extends2.default)({}, this.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 39,
              columnNumber: 25
            }
          }));
          break;

        case 'GOAL':
        case 'OWN_GOAL':
          header = period !== 'PENALTY_SHOOTOUT' ? _react.default.createElement(_Header.default, {
            minute: matchMinute,
            scoreHome: scoreHome,
            scoreAway: scoreAway,
            away: away,
            center: center,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45,
              columnNumber: 25
            }
          }) : header;
          event = _react.default.createElement(_Goal.default, (0, _extends2.default)({}, this.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 55,
              columnNumber: 25
            }
          }));
          break;

        case 'SUBSTITUTION':
          header = _react.default.createElement(_Header.default, {
            minute: matchMinute,
            substitution: true,
            away: away,
            center: center,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 58,
              columnNumber: 26
            }
          });
          event = _react.default.createElement(_Substitution.default, (0, _extends2.default)({}, this.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 59,
              columnNumber: 25
            }
          }));
          break;

        case 'END':
        case 'FULL_TIME':
        case 'START':
          center = true;
          header = _react.default.createElement(_Header.Whistle, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 65,
              columnNumber: 26
            }
          });
          event = _react.default.createElement(_Standard.default, {
            title: message,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 66,
              columnNumber: 25
            }
          });
          break;

        default:
          center = true;
          event = _react.default.createElement(_Standard.default, {
            content: message,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 70,
              columnNumber: 25
            }
          });
      }

      return _react.default.createElement(_Basic.Column, {
        mb: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74,
          columnNumber: 13
        }
      }, header, _react.default.createElement(_Basic.Row, {
        isFlex: true,
        center: center,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Column, {
        p: 2,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main",
        width: 280 / 360,
        ml: (0, _PropsHelper.getValueConditionally)(!center && away, 'auto'),
        isFlex: true,
        center: center,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77,
          columnNumber: 21
        }
      }, match, event)));
    }
  }]);
  return Event;
}(_react.default.Component);

exports.default = Event;
Event.propTypes = {
  type: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  matchMinute: _propTypes.default.string,
  away: _propTypes.default.bool,
  scoreHome: _propTypes.default.number,
  scoreAway: _propTypes.default.number,
  match: _propTypes.default.object
};